// Catalogue des avatars composés : chaque catégorie liste ses options, et un
// avatar n'est qu'un objet { catégorie: identifiant }. Les formes vivent dans
// components/Avatar/parts ; ici, uniquement les choix possibles.

export const SKIN_TONES = [
    { id: "porcelain", fill: "#FBDFCB", shade: "#F0C3A8" },
    { id: "ivory", fill: "#F8D2B4", shade: "#EAB692" },
    { id: "peach", fill: "#F1C09A", shade: "#E0A47A" },
    { id: "honey", fill: "#E3AC7E", shade: "#CE925F" },
    { id: "almond", fill: "#C68B5E", shade: "#AE7245" },
    { id: "bronze", fill: "#AD744B", shade: "#935D37" },
    { id: "chestnut", fill: "#8C5A3A", shade: "#74462A" },
    { id: "cocoa", fill: "#6B4129", shade: "#56311D" },
];

export const HAIR_COLORS = [
    { id: "black", fill: "#26202B", shade: "#15111A" },
    { id: "espresso", fill: "#3F2A20", shade: "#2C1C14" },
    { id: "brown", fill: "#5A3A28", shade: "#43291B" },
    { id: "chestnut", fill: "#8A5632", shade: "#6E4124" },
    { id: "auburn", fill: "#9C3F27", shade: "#7E2F1B" },
    { id: "ginger", fill: "#D2693A", shade: "#B4522A" },
    { id: "blond", fill: "#E6BC6A", shade: "#CFA04B" },
    { id: "platinum", fill: "#F1E6C8", shade: "#DCCDA5" },
    { id: "grey", fill: "#B9B6C2", shade: "#9C99A8" },
    { id: "violet", fill: "#613BDB", shade: "#4B2BB5" },
    { id: "blue", fill: "#3F8FE0", shade: "#2C74C2" },
    { id: "pink", fill: "#F08CB4", shade: "#DB6F9C" },
];

export const LIP_COLORS = [
    { id: "rose", fill: "#D9566B", shade: "#A93A52" },
    { id: "red", fill: "#C62F3B", shade: "#8E1F2A" },
    { id: "coral", fill: "#EC7A62", shade: "#C2573F" },
    { id: "pink", fill: "#EE7FA8", shade: "#C45A83" },
    { id: "berry", fill: "#A23A6B", shade: "#7A2850" },
    { id: "plum", fill: "#7B3A5A", shade: "#582640" },
    { id: "nude", fill: "#C98B79", shade: "#A46A59" },
    { id: "brown", fill: "#8A4B3C", shade: "#673529" },
];

export const EYE_COLORS = [
    { id: "dark", fill: "#3A2A22" },
    { id: "brown", fill: "#7A4B2A" },
    { id: "hazel", fill: "#9A7B35" },
    { id: "green", fill: "#4E9A63" },
    { id: "blue", fill: "#4A8FD6" },
    { id: "grey", fill: "#7D8794" },
];

export const CLOTH_COLORS = [
    { id: "violet", fill: "#613BDB", shade: "#4B2BB5" },
    { id: "orange", fill: "#E8511D", shade: "#C54012" },
    { id: "sky", fill: "#4C9FEA", shade: "#3384CF" },
    { id: "navy", fill: "#2F4A8A", shade: "#22386D" },
    { id: "mint", fill: "#3DBE94", shade: "#2CA17B" },
    { id: "forest", fill: "#2F7D5B", shade: "#226347" },
    { id: "butter", fill: "#F3C441", shade: "#DBA92A" },
    { id: "rose", fill: "#EE6F8E", shade: "#D65577" },
    { id: "red", fill: "#D8433F", shade: "#B8322F" },
    { id: "sand", fill: "#D9C2A0", shade: "#C2A77F" },
    { id: "ink", fill: "#2E2A3C", shade: "#1D1A28" },
    { id: "cloud", fill: "#F1EEF8", shade: "#D9D3EA" },
];

export const BACKGROUNDS = [
    { id: "lavender", fill: "#E3DCF9" },
    { id: "sky", fill: "#CFE6FB" },
    { id: "mint", fill: "#CDEFDF" },
    { id: "butter", fill: "#FBEBB5" },
    { id: "peach", fill: "#FBD9C6" },
    { id: "rose", fill: "#FAD3E0" },
    { id: "sand", fill: "#EFE6D6" },
    { id: "cloud", fill: "#ECEEF3" },
    { id: "violet", fill: "#613BDB" },
    { id: "orange", fill: "#E8511D" },
    { id: "teal", fill: "#1F8A8A" },
    { id: "ink", fill: "#2E2A3C" },
];

export const FACE_SHAPES = ["oval", "round", "square", "heart"];
export const HAIR_STYLES = [
    "short", "side", "quiff", "curtains", "fringe", "pixie", "spiky", "messy", "blaze", "warrior", "flat", "fade", "buzz", "mohawk",
    "undercut", "curly", "afro", "cornrows", "dreads", "boxbraids", "bob", "shoulder", "long", "longside", "wavy", "bun", "buns", "ponytail", "braids",
    "balding", "bald",
];
export const HEADWEAR = [
    "none", "beanie", "cap", "bucket", "strawhat", "beret", "tophat", "gradcap", "crown", "partyhat",
    "headband", "bandana", "plate", "bow", "flower", "catears", "headphones", "hijab",
];
export const EYES = ["round", "wide", "almond", "lash", "dot", "sleepy", "happy", "wink"];
export const BROWS = ["soft", "arched", "straight", "thick", "raised", "bold"];
export const NOSES = ["soft", "round", "button", "pointed"];
export const MOUTHS = ["smile", "teeth", "grin", "laugh", "smirk", "calm", "serious", "sad", "ooh", "lips", "lipsopen", "kiss"];
export const FACIAL_HAIR = [
    "none", "stubble", "pencil", "moustache", "handlebar", "walrus", "soulpatch", "goatee", "vandyke", "circle",
    "chinstrap", "sideburns", "shortbeard", "beard", "longbeard",
];
export const DETAILS = ["none", "freckles", "blush", "mole", "nosestud", "septum", "scar", "plaster"];
export const WRINKLES = ["none", "smile", "eyes", "forehead", "light", "marked"];
export const GLASSES = ["none", "round", "square", "thin", "half", "cat", "aviator", "sun", "roundsun", "heart"];
export const EARRINGS = ["none", "studs", "pearls", "hoops", "drops", "earbuds"];
export const NECKWEAR = ["none", "scarf", "bandana", "bowtie", "necklace", "pearls", "choker", "chain", "lanyard", "headset"];
export const BUILDS = ["regular", "slim", "muscular"];
export const TOPS = [
    "tee", "vneck", "graphic", "tank", "stripes", "sweater", "polo", "hoodie", "turtleneck", "cardigan",
    "shirt", "hawaiian", "mao", "blouse", "tie", "waistcoat", "jacket", "blazer", "suit", "labcoat",
    "denim", "leather", "bomber", "tracksuit", "puffer", "dress", "bardot", "overalls", "jersey", "gi",
];

const ids = (list) => list.map((item) => item.id);

// L'ordre est celui des onglets de l'écran de composition.
export const AVATAR_CATEGORIES = [
    { key: "skin", options: ids(SKIN_TONES), swatches: SKIN_TONES },
    { key: "face", options: FACE_SHAPES },
    { key: "hair", options: HAIR_STYLES },
    { key: "hairColor", options: ids(HAIR_COLORS), swatches: HAIR_COLORS },
    { key: "eyes", options: EYES },
    { key: "eyeColor", options: ids(EYE_COLORS), swatches: EYE_COLORS },
    { key: "brows", options: BROWS },
    { key: "nose", options: NOSES },
    { key: "mouth", options: MOUTHS },
    // Le rouge à lèvres ne se voit que sur une bouche dessinée avec ses lèvres.
    { key: "lipColor", options: ids(LIP_COLORS), swatches: LIP_COLORS, when: { mouth: ["lips", "lipsopen", "kiss"] } },
    { key: "facialHair", options: FACIAL_HAIR },
    { key: "wrinkles", options: WRINKLES },
    { key: "details", options: DETAILS },
    { key: "glasses", options: GLASSES },
    { key: "earrings", options: EARRINGS },
    { key: "headwear", options: HEADWEAR },
    { key: "neckwear", options: NECKWEAR },
    { key: "headwearColor", options: ids(CLOTH_COLORS), swatches: CLOTH_COLORS },
    { key: "build", options: BUILDS },
    { key: "top", options: TOPS },
    { key: "topColor", options: ids(CLOTH_COLORS), swatches: CLOTH_COLORS },
    { key: "background", options: ids(BACKGROUNDS), swatches: BACKGROUNDS },
];

// Regroupement des catégories dans l'écran de composition, avec l'icône Solar de chaque groupe.
export const AVATAR_GROUPS = [
    { key: "face", icon: "smile-circle-linear", categories: ["skin", "face", "eyes", "eyeColor", "brows", "nose", "mouth", "lipColor", "wrinkles", "details"] },
    { key: "hair", icon: "scissors-linear", categories: ["hair", "hairColor", "facialHair"] },
    { key: "accessories", icon: "crown-linear", categories: ["glasses", "earrings", "headwear", "neckwear", "headwearColor"] },
    { key: "outfit", icon: "t-shirt-linear", categories: ["build", "top", "topColor", "background"] },
];

export function hashSeed(seed) {
    const text = String(seed ?? "");
    let hash = 2166136261;
    for (let i = 0; i < text.length; i++) {
        hash ^= text.charCodeAt(i);
        hash = Math.imul(hash, 16777619);
    }
    return hash >>> 0;
}

// Ce que le tirage au sort a le droit de choisir. Trois règles :
// - on ne devine l'origine de personne : un avatar attribué d'office porte une teinte intermédiaire,
//   qui peut passer pour beaucoup de monde,
//   et aucune coiffure qui renvoie à une origine (afro, tresses collées, tresses longues) ;
// - aucun signe religieux n'est jamais attribué d'office (le voile reste un choix du membre) ;
// - le fantaisiste (cheveux bleus, lunettes cœur, couronne) se choisit, il ne se tire pas au sort.
const RANDOM_POOLS = {
    skin: ["peach", "honey"],
    hair: HAIR_STYLES.filter((hair) => !["afro", "cornrows", "dreads", "boxbraids"].includes(hair)),
    background: ids(BACKGROUNDS).slice(0, 8),
    hairColor: ids(HAIR_COLORS).slice(0, 9),
    eyes: ["round", "wide", "almond", "dot"],
    mouth: ["smile", "teeth", "grin", "smirk", "calm"],
    lipColor: ["rose", "coral", "nude"],
    build: ["regular"],
    wrinkles: ["none"],
    glasses: ["round", "square", "thin", "half"],
    headwear: ["beanie", "cap", "bucket", "headband", "headphones"],
    neckwear: ["scarf", "necklace", "headset"],
    details: ["freckles", "blush", "mole"],
};

// Le tirage se tient au genre qu'on lui donne : coiffure, barbe et bijoux.
const GENDER_POOLS = {
    male: {
        hair: ["short", "side", "quiff", "curtains", "spiky", "messy", "flat", "fade", "buzz", "undercut", "curly", "balding", "bald"],
        facialHair: ["stubble", "moustache", "goatee", "circle", "shortbeard", "beard"],
        earrings: ["studs", "earbuds"],
    },
    // Prénom mixte, pseudonyme ou inconnu : un personnage qui peut passer pour l'un comme pour l'autre.
    neutral: {
        hair: ["short", "side", "curtains", "fringe", "messy", "curly", "bob"],
        facialHair: [],
        earrings: ["studs", "earbuds"],
    },
    female: {
        hair: ["fringe", "pixie", "bob", "shoulder", "long", "longside", "wavy", "bun", "buns", "ponytail", "braids", "curly"],
        facialHair: [],
        eyes: ["round", "wide", "almond", "lash"],
        mouth: ["smile", "teeth", "grin", "calm", "lips", "lipsopen"],
        earrings: ["studs", "pearls", "hoops", "drops"],
    },
};

// Un avatar stable pour qui n'a encore rien composé : le même identifiant (et le même
// genre, "male", "female", "neutral" ou rien) donne toujours le même personnage.
export function avatarFromSeed(seed, { gender } = {}) {
    let state = hashSeed(seed) || 1;
    const pick = (options) => {
        state = (Math.imul(state, 1664525) + 1013904223) >>> 0;
        return options[(state >>> 8) % options.length];
    };
    const oneIn = (n) => pick(Array.from({ length: n }, (_, i) => i)) === 0;
    const pools = { ...RANDOM_POOLS, ...GENDER_POOLS[gender] };
    // Robe, haut épaules nues et chemisier ne sortent d'un tirage que pour un prénom féminin.
    if (gender !== "female") pools.top = TOPS.filter((top) => !["dress", "bardot", "blouse"].includes(top));
    const avatar = {};
    for (const category of AVATAR_CATEGORIES) {
        const pool = pools[category.key];
        avatar[category.key] = pool ? (pool.length ? pick(pool) : "none") : pick(category.options);
    }
    // Barbe, lunettes et accessoires restent l'exception, pas la règle.
    if (!oneIn(4)) avatar.facialHair = "none";
    if (!oneIn(4)) avatar.glasses = "none";
    if (!oneIn(5)) avatar.headwear = "none";
    if (!oneIn(4)) avatar.details = "none";
    if (!oneIn(gender === "female" ? 2 : 6)) avatar.earrings = "none";
    if (!oneIn(5)) avatar.neckwear = "none";
    return avatar;
}

// Un avatar à dessiner : un objet, sauf la marque laissée par le membre qui a supprimé le
// sien (origin: "removed"). Cette marque empêche l'attribution d'office de lui en redonner un.
export const REMOVED_AVATAR = { origin: "removed" };
export const isDrawnAvatar = (value) => Boolean(value) && typeof value === "object" && !Array.isArray(value) && value.origin !== "removed";

// Les catégories qui acceptent des pièces ajoutées sans redéploiement (lib/avatar/pieces.js).
export const CUSTOM_CATEGORIES = ["hair", "headwear", "neckwear", "earrings", "glasses", "details", "top", "mouth"];
const CUSTOM_OPTION = /^[a-z0-9-]{1,24}$/;

// Complète un avatar partiel ou ancien : toute valeur inconnue retombe sur
// celle de la graine, pour qu'un retrait d'option ne casse aucun affichage.
// Exception : dans une catégorie qui accepte des pièces ajoutées, une valeur hors
// catalogue est gardée telle quelle. C'est le dessin qui tranche : si la pièce existe
// en base elle est dessinée, sinon rien n'est dessiné à cet endroit.
export function normalizeAvatar(avatar, seed) {
    const fallback = avatarFromSeed(seed);
    const result = {};
    for (const category of AVATAR_CATEGORIES) {
        const value = avatar?.[category.key];
        const custom = CUSTOM_CATEGORIES.includes(category.key) && typeof value === "string" && CUSTOM_OPTION.test(value);
        result[category.key] = category.options.includes(value) || custom ? value : fallback[category.key];
    }
    return result;
}

// Le bouton « Au hasard » de l'écran de composition : c'est le membre qui tire, toutes
// les teintes de peau sont donc permises.
export function randomAvatar(options) {
    const avatar = avatarFromSeed(`${Date.now()}-${Math.random()}`, options);
    const tones = ids(SKIN_TONES);
    return { ...avatar, skin: tones[Math.floor(Math.random() * tones.length)] };
}
